import { DateTime } from 'luxon';

import { ForgotPasswordFormValues, ForgotPasswordRequestDto } from '../types';
import { convertToDateString, getCompanyName } from 'theSource/utils';

const mapBirthDate = (birthDate: Date): string => {
  if (DateTime.isDateTime(birthDate)) {
    return convertToDateString(birthDate);
  }
  return birthDate.toDateString();
};

export const mapForgotPasswordFormValues = (
  data: ForgotPasswordFormValues
): ForgotPasswordRequestDto => ({
  user_name: data.userName,
  last_name: data.lastName,
  date_of_birth: mapBirthDate(data.birthDate),
  last_four_ssn: data.lastFourDigitsOfSsn!,
  org_code: getCompanyName(),
});
